module.exports = {"TXTCLI_Invalid_date":{"id":"TXTCLI_Invalid_date","defaultMessage":"Data non valida","track":"Invalid date"}}